module.exports = __webpack_public_path__ + "media/img/home/img_hk-ff8b159c5404b5b2edcb2f629e2d2f31.png";